import { render, staticRenderFns } from "./LmsDisabled.vue?vue&type=template&id=3c06ad57&scoped=true&"
import script from "./LmsDisabled.vue?vue&type=script&lang=js&"
export * from "./LmsDisabled.vue?vue&type=script&lang=js&"
import style0 from "./LmsDisabled.vue?vue&type=style&index=0&id=3c06ad57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06ad57",
  null
  
)

export default component.exports